import { Injectable } from "@angular/core";
import { RenderObject } from "./render-object";
import { MeshLoader } from "./mesh-loader";
import { TextureLoader } from "./texture-loader";
import { ShaderProgram } from "../webgl/webgl-program";
import { RenderContext } from "../webgl/webgl-context";
import { PngDecoder } from "./png-decoder";
var RenderBatch = (function () {
    function RenderBatch(mesh_loader_, texture_loader_, gl_, program_) {
        this.mesh_loader_ = mesh_loader_;
        this.texture_loader_ = texture_loader_;
        this.gl_ = gl_;
        this.program_ = program_;
        this.render_objects_ = new Map();
    }
    ;
    RenderBatch.prototype.start = function (object_ids) {
        var _this = this;
        for (var _i = 0, object_ids_1 = object_ids; _i < object_ids_1.length; _i++) {
            var id = object_ids_1[_i];
            this.render_objects_.set(id, new RenderObject(id));
        }
        this.render_objects_.forEach(function (object) {
            object.start(_this.mesh_loader_);
        });
    };
    ;
    RenderBatch.prototype.drawAll = function (models) {
        var transform = new Float32Array(16);
        transform.set(models.subarray(32, 48));
        this.render_objects_.get("cube_low").draw(this.gl_.context, this.program_, transform);
    };
    ;
    RenderBatch.decorators = [
        { type: Injectable },
    ];
    RenderBatch.ctorParameters = function () { return [
        { type: MeshLoader, },
        { type: TextureLoader, },
        { type: RenderContext, },
        { type: ShaderProgram, },
    ]; };
    return RenderBatch;
}());
export { RenderBatch };
//# sourceMappingURL=render-batch.js.map